import { AuthService } from './../../shared/models/auth.service';
import { Component, OnInit, ViewChild, Output } from '@angular/core';
import {
  ApplicationRouteURL,
  RoleLevel,
  IAPIResponse,
  PermissionType,
  IKeyValueInterface
} from '../../shared/config';

import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { PrivacyStatementPopup } from '../models/privacy-popup.service';
import { TermsConditionActivityLog } from './../../termsconditionpopup/models/terms-condition.model';
import { EventEmitter } from 'events';
import { TNCAction } from '../../shared/models/enum-helper';

@Component({
    selector: 'Wego-Popup-PrivacyStatement',
    template: require('../views/privacy-statement-popup.component.html'),
    providers: [PrivacyStatementPopup]
  })

  export class ViewPrivacyStatementPopupComponent implements OnInit {
    
    urlTermsAndConditionPopup: string;
    termsConditionActivityLogModel: TermsConditionActivityLog;
    instanceHashID: string;
    termsAndConditionHashId: string;
    apiErrorMsg: string;
    errorModel: IKeyValueInterface[];
    errorMessage: string;
    bodyHTMLText: string;
    isLoading: boolean = false;

    constructor(
        public authService: AuthService,
        private locationService: Location,
        private router: Router,
        private activeRoute: ActivatedRoute,
        private termsConditionPopup: PrivacyStatementPopup
      ) {}

      ngOnInit() {
        this.termsConditionActivityLogModel = new TermsConditionActivityLog();
        this.urlTermsAndConditionPopup = this.authService.GetURL(
          ApplicationRouteURL.URL_PRIVACY_STATEMENT_POPUP
        );

        this.CheckAccountActivationTermsConditionStatus();
      }

      public CheckAccountActivationTermsConditionStatus() {
        this.isLoading = true;
        this.authService.CheckAccountActivationPrivacyStatus().subscribe(
          res => {
            const isAccepted: boolean = res.data.accepted;
            if (!isAccepted) {
              this.bodyHTMLText = res.data.content;
              this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
            } else {
              this.NavigateTo();
            }
            this.isLoading = false;
          },
          error => {
            this.authService.HandleErrorStatusCode(error);
            this.isLoading = false;
          }
        );
      }

      public NavigateTo() {
        this.router.navigate(['/driver']);
      }
    
      public OnRejectClick(action: number) {
        this.ActionOnAccountActivationTermsCondition(
          this.termsAndConditionHashId,
          TNCAction.REJECTED
        );
      }
    
      public Logout() {
        this.authService.Logout();
        this.router.navigate(['/']);
      }
    
      OnAcceptClick(action: number) {
        this.ActionOnAccountActivationTermsCondition(
          this.termsAndConditionHashId,
          TNCAction.ACCEPTED
        );
      }

      public ActionOnAccountActivationTermsCondition(
        tncHashId: string,
        action: number
      ) {
        this.termsConditionPopup
          .ActionOnAccountActivationTermsCondition(tncHashId, action)
          .subscribe(
            res => {
              if (action == TNCAction.ACCEPTED) {
                this.NavigateTo();
              } else {
                this.Logout();
              }
              console.log('Privacy Statement updated successfully');
            },
            error => {}
          );
      }
  }


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/privacypopup/component/privacy-statement-popup.component.ts